var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h3", { staticClass: "grey-color mb-3 main_text font-weight-bold" }, [
        _vm._v("Личный кабинет"),
      ]),
      _c(
        "b-card",
        { staticClass: "my-2" },
        [
          _c(
            "b-button",
            {
              staticClass: "text-uppercase",
              attrs: {
                variant: "custom-outline-secondary",
                href: "https://info.zakupschik.ru/files/download/8685f9ea-198b-11f1-8f50-fa163e2ff576",
                target: "_blank",
              },
            },
            [
              _c("b-icon", {
                staticClass: "mr-2",
                attrs: { icon: "exclamation-circle" },
              }),
              _vm._v("Памятка по работе в ИС АТМО"),
            ],
            1
          ),
        ],
        1
      ),
      _c("h4", { staticClass: "grey-color my-3 main_text font-weight-bold" }, [
        _vm._v("Состояние лицевого счета:"),
      ]),
      _vm.balance
        ? _c(
            "b-row",
            {
              staticClass: "border-bottom my-2 account_block",
              attrs: { "no-gutters": "" },
            },
            [
              _c("b-col", { staticClass: "my-2", attrs: { lg: "4" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column align-items-center px-3" },
                  [
                    _c("div", { staticClass: "cust_label total" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$formatPrice(_vm.balance.total)) + " "
                      ),
                    ]),
                    _c(
                      "p",
                      { staticClass: "mt-2 mb-0 text-center fs-14 grey-color" },
                      [_vm._v("Депозит")]
                    ),
                  ]
                ),
              ]),
              _c("b-col", { staticClass: "my-2", attrs: { lg: "4" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column align-items-center px-3" },
                  [
                    _c("div", { staticClass: "cust_label available" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$formatPrice(_vm.balance.available)) +
                          " "
                      ),
                    ]),
                    _c(
                      "p",
                      { staticClass: "mt-2 mb-0 text-center fs-14 grey-color" },
                      [_vm._v("Доступные")]
                    ),
                  ]
                ),
              ]),
              _c("b-col", { staticClass: "my-2", attrs: { lg: "4" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column align-items-center px-3" },
                  [
                    _c("div", { staticClass: "cust_label blocked" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$formatPrice(_vm.balance.blocked)) +
                          " "
                      ),
                    ]),
                    _c(
                      "p",
                      { staticClass: "mt-2 mb-0 text-center fs-14 grey-color" },
                      [_vm._v("Заблокированные")]
                    ),
                  ]
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-button",
        {
          staticClass: "text-uppercase my-2",
          attrs: {
            variant: "custom-green",
            to: { name: "CabinetAccountingReconciliationReports" },
          },
        },
        [_vm._v(" Акты сверки ")]
      ),
      _vm.$store.getters.getCertificateNeedToBeProlonged
        ? _c("b-card", { staticClass: "my-2" }, [
            _c("p", { staticClass: "text-danger font-weight-bold py-0 my-0" }, [
              _vm._v(
                "Срок действия вашей ЭЦП истекает " +
                  _vm._s(
                    _vm.getDateTimeFormat(
                      _vm.$store.getters.getCertificateValidTo
                    )
                  ) +
                  "."
              ),
            ]),
          ])
        : _vm._e(),
      _vm.$store.getters.getPOANeedToBeProlonged
        ? _c("b-card", { staticClass: "my-2" }, [
            _c("p", { staticClass: "text-danger font-weight-bold py-0 my-0" }, [
              _vm._v(
                "Срок действия вашей МЧД истекает " +
                  _vm._s(
                    _vm.getDateTimeFormat(_vm.$store.getters.getPOAValidTo)
                  ) +
                  "."
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }